import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { IErrorHandler } from '../../dataModels/contracts/IErrorHandler';
import { Configuration } from '../../configurations/shared.config';
import { LocalizePipe } from '../../pipes/Localize.pipe';
import { AuthenticationService } from '../../services/authentication.service';
import { SignalRNotificationService } from '../../services/signalR-notification.service';
import { HttpService } from '../../services/http.service';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: '[notification-list]',
    templateUrl: 'notification.component.html',
    providers: [LocalizePipe]
})
export class NotificationComponent implements OnInit {

    private _errorHandler: IErrorHandler;
    notificationLst: any;
    notificationCount: number = 0;

    constructor(private auth: AuthenticationService, private _signalRService: SignalRNotificationService, private _http: HttpService,
        @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe, private router: Router) {
        this._errorHandler = handler;

        this.getTopNotifications();
    }

    ngOnInit() {
        this._signalRService.notificationReceived.subscribe(id => {
            this.receiveNotification(id);
        });

        this._signalRService.notificationMarkedAsRead.subscribe(data => {
            this.notificationChanged(data);
        });

    }

    receiveNotification(notification) {
        this.notificationLst.unshift(notification);
        this.updateUnReadNotificationCount();
    }

    notificationChanged(id: number) {
        var notification = this.notificationLst.find(x => x.Id == id);
        if (notification) {
            notification.IsRead = true;
            //this.updateUnReadNotificationCount();
            this.notificationCount--;

        }

    }

    getTopNotifications() {
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.userNotificationApi).map(response => response.json())
            .subscribe(response => {
                if (!response.IsErrorState && response.Value) {
                    this.notificationLst = response.Value.Collection;
                    //this.updateUnReadNotificationCount();
                    this.notificationCount = response.Value.TotalCount;
                    // console.log(response.Value)
                }
                else {
                }
            },
                error => {
                    this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
                });

    }

    changeNotificationStatus(event, id: number) {

        var notification = this.notificationLst.find(x => x.Id == id);
        if (notification && !notification.IsRead) {
            this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.UpdateNotificationStatus + id + "/" + this.auth.staffId, null, false).subscribe();
            //this._signalRService.changeNotificationStatus(id);
        }
        event.stopPropagation();

    }

    changeAllNotificationStatus(event) {


        //this._signalRService.changeAllNotificationStatus();
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.UpdateAllNotificationStatus + this.auth.staffId, null, false).subscribe();
        event.stopPropagation();

    }

    updateUnReadNotificationCount() {
        this.notificationCount++;
        //this.notificationCount = this.notificationLst.filter(function (element) {
        //    return element.IsRead == false;
        //}).length;

    }

    redirectToNotificationSettings() {
        this.router.navigateByUrl(Configuration.paths.notificationSettings);
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/notification/notification.component.ts